const ONLINE_TEXTS = new Set(['online', 'up', 'connected', 'healthy', 'true', '1', 'active', 'enabled']);
const OFFLINE_TEXTS = new Set(['offline', 'down', 'disconnected', 'false', '0', 'inactive', 'unreachable', 'disabled']);

export const toOptionalBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (value === null || value === undefined) return null;
  const text = String(value).trim().toLowerCase();
  if (!text) return null;
  if (ONLINE_TEXTS.has(text)) return true;
  if (OFFLINE_TEXTS.has(text)) return false;
  return null;
};

const pickFirstNonNullBool = (...candidates) => {
  for (const candidate of candidates) {
    const parsed = toOptionalBoolean(candidate);
    if (parsed !== null) return parsed;
  }
  return null;
};

const pickFirstValidDateMs = (...candidates) => {
  for (const candidate of candidates) {
    if (candidate === null || candidate === undefined || candidate === '') continue;
    const parsed = Date.parse(String(candidate));
    if (!Number.isNaN(parsed)) return parsed;
  }
  return null;
};

export const resolveRouterOnlineState = (row) => {
  const monitoringLiveTrafficSeen = pickFirstNonNullBool(
    row?.monitoring_live_traffic_seen,
    row?.monitoringLiveTrafficSeen,
    row?.monitoring?.live_traffic_seen,
    row?.raw?.monitoring_live_traffic_seen,
  );
  const monitoringOnline = pickFirstNonNullBool(
    row?.monitoring_is_online,
    row?.monitoringOnline,
    row?.monitoring?.is_online,
    row?.raw?.monitoring_is_online,
  );
  const nasRuntimeOnline = pickFirstNonNullBool(
    row?.nas_runtime_is_online,
    row?.nasRuntimeOnline,
    row?.raw?.nas_runtime_is_online,
  );
  const nasRuntimeCheckedAtMs = pickFirstValidDateMs(
    row?.nas_runtime_checked_at,
    row?.nasRuntimeCheckedAt,
    row?.raw?.nas_runtime_checked_at,
    row?.updated_at,
    row?.raw?.updated_at,
  );
  const nasRuntimeFresh =
    nasRuntimeOnline === null
      ? false
      : nasRuntimeCheckedAtMs !== null
        ? (Date.now() - nasRuntimeCheckedAtMs) <= (10 * 60 * 1000)
        : false;
  const trustedNasRuntimeOnline = nasRuntimeFresh ? nasRuntimeOnline : null;
  const isOnlineField = pickFirstNonNullBool(
    row?.isOnline,
    row?.is_online,
    row?.raw?.is_online,
  );
  const trustedMonitoringOnline = monitoringLiveTrafficSeen === false ? null : monitoringOnline;
  const resolvedOnline = trustedNasRuntimeOnline ?? trustedMonitoringOnline ?? isOnlineField ?? false;
  const sourceAuthority =
    trustedNasRuntimeOnline !== null
      ? 'NAS_RUNTIME'
      : trustedMonitoringOnline !== null
        ? 'MONITORING'
        : isOnlineField !== null
          ? 'ROUTER_FIELD'
          : 'UNKNOWN';
  const hasMismatch =
    trustedMonitoringOnline !== null
    && trustedNasRuntimeOnline !== null
    && trustedMonitoringOnline !== trustedNasRuntimeOnline;

  return {
    isOnline: Boolean(resolvedOnline),
    sourceAuthority,
    monitoringOnline: trustedMonitoringOnline,
    nasRuntimeOnline: trustedNasRuntimeOnline,
    nasRuntimeFresh,
    label: undefined,
    hasMismatch,
  };
};

export default resolveRouterOnlineState;
